"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createStyles = _interopRequireDefault(require("@material-ui/core/styles/createStyles"));
var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var useStyles = (0, _makeStyles.default)(theme => (0, _createStyles.default)({
  root: {
    height: '48px',
    borderRadius: 0
  },
  primaryRoot: {
    backgroundColor: 'transparent',
    border: "2px solid ".concat(theme.palette.common.black),
    color: theme.palette.common.black,
    '&:hover': {
      backgroundColor: 'rgba(57, 57, 57, 0.2)',
      color: theme.palette.common.black
    },
    '&:focus': {
      color: theme.palette.common.black
    },
    '&:disabled': {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.custom.grey.light,
      borderColor: theme.palette.custom.grey.light
    }
  },
  secondaryRoot: {
    backgroundColor: 'rgba(255, 255, 255, 0)',
    border: "2px solid ".concat(theme.palette.common.white),
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.common.black,
      border: "2px solid ".concat(theme.palette.secondary.main)
    },
    '&:focus': {
      color: theme.palette.common.black,
      border: "2px solid ".concat(theme.palette.secondary.main)
    }
  },
  containedRoot: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    border: 'none',
    '&:hover': {
      backgroundColor: 'rgba(38, 38, 38, 0.9)',
      color: theme.palette.common.white
    },
    '&:focus': {
      color: theme.palette.common.white
    },
    '&:disabled': {
      color: theme.palette.custom.grey.light,
      backgroundColor: theme.palette.custom.grey.main,
      border: 0
    },
    '& span': {
      color: theme.palette.common.white
    }
  }
}), {
  name: 'Button'
});
var _default = exports.default = useStyles;